import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d370f708"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "loading",
  width: "48",
  height: "16",
  viewBox: "0 0 48 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("circle", {
  cx: "12",
  cy: "8",
  r: "3",
  fill: "#dfe1e6"
}, null, -1 /* HOISTED */))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("circle", {
  cx: "24",
  cy: "8",
  r: "3",
  fill: "#00479d"
}, null, -1 /* HOISTED */))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("circle", {
  cx: "36",
  cy: "8",
  r: "3",
  fill: "#dfe1e6"
}, null, -1 /* HOISTED */))
const _hoisted_5 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4
]
const _hoisted_6 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode($setup["BaseInput"], {
      ref: "baseInput",
      placeholder: $props.placeholder,
      type: $props.type,
      name: $props.name,
      label: $props.label,
      maxlength: $props.maxlength,
      errorMessage: $props.errorMessage,
      successMessage: $props.successMessage,
      disabled: $props.disabled,
      required: $props.required,
      enableClearText: $props.enableClearText,
      value: $setup.inputValue,
      "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => (($setup.inputValue) = $event)),
      rules: $props.rules,
      onOnInput: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('onInput'))),
      onOnFocused: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('onFocused'))),
      onOnBlurred: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('onBlurred')))
    }, {
      inputInnerButton: _withCtx(({ valid }) => [
        _renderSlot(_ctx.$slots, "extraElement", {}, undefined, true),
        ($props.isLoading)
          ? (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_5]))
          : (_openBlock(), _createElementBlock("button", {
              key: 1,
              ref: "button",
              class: "btn",
              type: "button",
              disabled: $props.disabled || !valid,
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('onClickButton')))
            }, _toDisplayString($props.buttonTitle), 9 /* TEXT, PROPS */, _hoisted_6))
      ]),
      _: 3 /* FORWARDED */
    }, 8 /* PROPS */, ["placeholder", "type", "name", "label", "maxlength", "errorMessage", "successMessage", "disabled", "required", "enableClearText", "value", "rules"])
  ]))
}